import { Component, Vue } from "vue-property-decorator";
// import awsApi from "@/sites/user/api/aws";
import { AwsService as awsApi } from "@/common/api/services/AwsService";

@Component
class GenerateCdnCookie extends Vue {
  isShow;
  intervalRequest = null;
  created() {
    this.requestCookie();
  }

  unmounted() {
    this.intervalRequest && clearInterval(this.intervalRequest);
  }

  async requestCookie() {
    if (!this.$cookies.isKey("CloudFront-Key-Pair-Id")) {
      const result = await awsApi.awsCdnPresign({});
      if (result.data.presign) {
        const dataPresign = result.data.presign;
        const rootDomain = process.env.VUE_APP_CDN_IMAGE_ROOT_DOMAIN;
        // { expires: '1d', path: '/', secure: true, sameSite: 'None' }
        this.$cookies.set(
          "CloudFront-Key-Pair-Id",
          dataPresign.cloudFrontKeyPairId,
          60 * 60 * 12,
          "/",
          rootDomain,
          true,
          "None"
        );
        this.$cookies.set(
          "CloudFront-Policy",
          dataPresign.cloudFrontPolicy,
          60 * 60 * 12,
          "/",
          rootDomain,
          true,
          "None"
        );
        this.$cookies.set(
          "CloudFront-Signature",
          dataPresign.cloudFrontSignature,
          60 * 60 * 12,
          "/",
          rootDomain,
          true,
          "None"
        );
      }
      this.isShow = true;
    } else {
      this.isShow = true;
    }
    // this.loopRequestCdn();
  }

  loopRequestCdn() {
    this.intervalRequest = setInterval(() => {
      if (!this.$cookies.isKey("CloudFront-Key-Pair-Id")) {
        this.requestCookie();
      }
    }, 1000);
  }

  resetCookie() {
    this.$cookies.remove("CloudFront-Key-Pair-Id");
    this.requestCookie();
  }
}
export default GenerateCdnCookie;
